<template lang="pug">
.auto-edit-table
  .with-actions(v-if='title')
    slot(name='title'): h1(v-if='title') {{title}}
    .ui.buttons.actions.no-print
      slot(name='actions')
      .ui.basic.button(v-if='buttonAdd', @click='create')
        i.add.icon.themed.text.inline
        span.themed.text 新增项目
  slot(name='afterTitle')

  auto-table(ref='table', :defines='defines',
    :unstackable='unstackable', :data='data', :filters='filters',
    :pagesize='pagesize', :layout='layout', :summary='summary',
    :sortable='sortable', :detail-view='detailView',
    :page-reset-on-change='pageResetOnChange',
    :actions='actions || "edit"', @action:edit='edit')

  el-dialog(:visible.sync='dialog.visible', size='large')
    template(v-if='dialog.visible')
      slot(name='form', scope='dialog')
        auto-form(
          :defines='defines',
          :form.sync='dialog.form',
          :form-type='dialog.type',
          :meta='formMeta',
          :title='dialog.title',
          @submitted='dialog_close',
          @cancel='dialog_close',
        )
</template>

<script>
import AutoTable from './AutoTable.vue'
import AutoForm from './AutoForm.vue'

export default {
  name: 'auto-edit-table',
  components: { AutoTable, AutoForm },
  props: {
    defines: Object,
    data: Array,
    title: String,
    titleClasses: String,
    unstackable: { default: true },
    summary: null,
    actions: null,
    sortable: null,
    detailView: { default: true },
    layout: { type: String, default: 'default' },
    pageResetOnChange: { type: Boolean, default: true },
    buttonAdd: { type: Boolean, default: true },
    pagesize: { type: Number, default: 30 },
    filters: Array,
    formMeta: null,
  },
  mounted() {
    // Hack to bypass actions
    this.$refs.table.$beforeEmit = (name, ...payload) => {
      if (name.startsWith('action'))
        this.$emit(name, ...payload)
    }
  },
  data() {
    return {
      dialog: {
        visible: false,
        form: {},
        type: 'modify',
        title: '编辑',
      },
    }
  },
  methods: {
    create() {
      this.dialog.form = {}
      this.dialog.type = 'create'
      this.dialog.title = '新建'
      this.dialog.visible = true
    },
    edit(record) {
      this.dialog.form = Object.assign({}, record)
      this.dialog.type = 'modify'
      this.dialog.title = '编辑'
      this.dialog.visible = true
    },
    dialog_close() {
      this.dialog.visible = false
    },
    dialog_open() {
      this.dialog.visible = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// AutoEditTable.vue?10299750